function accessTokenSelector(state: sage.state.IRedux): string | null {
    return state.user.accessToken;
}

export default accessTokenSelector;
